/* Interactivite des pages piliers et articles, Boutique Demon Slayer.
   Charge par sections/ds-pilier.liquid (asset ds-composants.js).
   Sans ce script, tout le contenu reste lisible : il ne fait qu'ajouter. */
(function () {
  var racine = document.querySelector('.ds-pilier');
  if (!racine) return;
  var doc = document.documentElement;
  doc.classList.add('ds-js');

  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = 'IntersectionObserver' in window;

  /* Largeur de la barre de defilement : les blocs pleine largeur la retranchent */
  function majLargeur() {
    doc.style.setProperty('--ds-scrollbar', Math.max(0, window.innerWidth - doc.clientWidth) + 'px');
  }
  majLargeur();
  window.addEventListener('resize', majLargeur);

  /* Barre de lecture en forme de sabre */
  var barre = document.createElement('div');
  barre.className = 'ds-progress';
  barre.setAttribute('aria-hidden', 'true');
  barre.innerHTML = '<div class="ds-progress__lame"></div>';
  document.body.appendChild(barre);
  var lame = barre.firstChild;
  function majBarre() {
    var r = racine.getBoundingClientRect();
    var total = r.height - window.innerHeight;
    var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 1;
    lame.style.width = (p * 100).toFixed(2) + '%';
  }

  /* Sommaire collant : il se cale sous l'en-tete du theme quand celui-ci reapparait */
  var sommaire = racine.querySelector('.ds-nav');
  var entete = document.querySelector('sticky-header') || document.querySelector('.section-header');
  var basEntete = -1;
  function majSommaire() {
    if (!sommaire || !entete) return;
    var bas = Math.max(0, Math.round(entete.getBoundingClientRect().bottom));
    if (bas !== basEntete) { basEntete = bas; sommaire.style.setProperty('--ds-nav-top', bas + 'px'); }
  }

  /* Le theme anime son en-tete apres le defilement : on suit quelques images de plus */
  var suiviJusqua = 0;
  var enCours = false;
  function boucle() {
    majBarre();
    majSommaire();
    if (Date.now() < suiviJusqua) window.requestAnimationFrame(boucle);
    else enCours = false;
  }
  window.addEventListener('scroll', function () {
    suiviJusqua = Date.now() + 500;
    if (!enCours) { enCours = true; window.requestAnimationFrame(boucle); }
  }, { passive: true });
  majBarre();
  majSommaire();

  /* Apparition au defilement */
  var animes = racine.querySelectorAll('.ds-reveal, .ds-frise__etape');
  if (io && !reduit) {
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    animes.forEach(function (el) { obs.observe(el); });
  } else {
    animes.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Sommaire : chapitre en cours */
  var nav = racine.querySelector('.ds-nav__rail');
  if (nav && io) {
    var liens = {};
    nav.querySelectorAll('a[href^="#"]').forEach(function (a) {
      var cible = document.getElementById(a.getAttribute('href').slice(1));
      if (cible) liens[cible.id] = a;
    });
    var obsNav = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        var a = liens[e.target.id];
        if (!a) return;
        Object.keys(liens).forEach(function (id) { liens[id].classList.remove('is-actif'); });
        a.classList.add('is-actif');
        nav.scrollTo({ left: a.offsetLeft - nav.clientWidth / 2 + a.clientWidth / 2, behavior: reduit ? 'auto' : 'smooth' });
      });
    }, { rootMargin: '-25% 0px -65% 0px' });
    Object.keys(liens).forEach(function (id) { obsNav.observe(document.getElementById(id)); });
  }

  /* Onglets : les boutons sont crees ici, a partir de data-titre */
  racine.querySelectorAll('.ds-onglets').forEach(function (bloc, n) {
    var panneaux = Array.prototype.filter.call(bloc.children, function (c) { return c.classList.contains('ds-onglet'); });
    if (panneaux.length < 2) return;
    var liste = document.createElement('div');
    liste.className = 'ds-onglets__liste';
    liste.setAttribute('role', 'tablist');
    var boutons = panneaux.map(function (p, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ds-onglets__bouton';
      b.id = 'ds-onglet-' + n + '-' + i;
      b.setAttribute('role', 'tab');
      b.textContent = p.getAttribute('data-titre') || ('Onglet ' + (i + 1));
      if (p.getAttribute('data-couleur')) b.setAttribute('data-couleur', p.getAttribute('data-couleur'));
      p.setAttribute('role', 'tabpanel');
      p.setAttribute('aria-labelledby', b.id);
      b.addEventListener('click', function () { activer(i); });
      liste.appendChild(b);
      return b;
    });
    bloc.insertBefore(liste, bloc.firstChild);
    function activer(i) {
      panneaux.forEach(function (p, j) {
        p.hidden = j !== i;
        boutons[j].setAttribute('aria-selected', j === i ? 'true' : 'false');
        boutons[j].classList.toggle('is-actif', j === i);
      });
    }
    activer(0);
  });

  /* Cartes qui se retournent (clic et clavier, pour le tactile) */
  racine.querySelectorAll('.ds-flip').forEach(function (c) {
    c.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      c.classList.toggle('is-retourne');
    });
    c.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); c.classList.toggle('is-retourne'); }
    });
  });

  /* Hauteur des cartes qui se retournent : celle du texte le plus long de la grille (26/10/2026,
     le dos debordait de son cadre sur mobile). Recalculee au redimensionnement et apres les polices. */
  function hauteurNaturelle(f) {
    var cs = getComputedStyle(f), e = f.children, haut = Infinity, bas = -Infinity;
    for (var k = 0; k < e.length; k++) {
      var r = e[k].getBoundingClientRect();
      if (r.height) { haut = Math.min(haut, r.top); bas = Math.max(bas, r.bottom); }
    }
    if (bas < haut) return 0;
    return Math.ceil(bas - haut + parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom)
      + parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth));
  }
  function ajusterFlips() {
    var groupes = [];
    racine.querySelectorAll('.ds-flip').forEach(function (c) {
      if (groupes.indexOf(c.parentElement) < 0) groupes.push(c.parentElement);
    });
    groupes.forEach(function (g) {
      var cartes = [].slice.call(g.children).filter(function (c) { return c.classList.contains('ds-flip'); });
      cartes.forEach(function (c) {
        c.style.minHeight = '';
        var i = c.querySelector('.ds-flip__interieur');
        if (i) i.style.minHeight = '';
      });
      var h = 0;
      cartes.forEach(function (c) {
        c.querySelectorAll('.ds-flip__face, .ds-flip__dos').forEach(function (f) { h = Math.max(h, hauteurNaturelle(f)); });
      });
      cartes.forEach(function (c) {
        if (h > c.offsetHeight) {
          c.style.minHeight = h + 'px';
          var i = c.querySelector('.ds-flip__interieur');
          if (i) i.style.minHeight = h + 'px';
        }
      });
    });
  }
  if (racine.querySelector('.ds-flip')) {
    ajusterFlips();
    var minuteurFlips;
    window.addEventListener('resize', function () { clearTimeout(minuteurFlips); minuteurFlips = setTimeout(ajusterFlips, 150); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajusterFlips);
  }

  /* Spoilers : flou jusqu'au clic */
  racine.querySelectorAll('.ds-spoiler').forEach(function (s) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ds-spoiler__bouton';
    b.textContent = s.getAttribute('data-libelle') || 'Révéler le spoiler';
    b.addEventListener('click', function () { s.classList.add('is-revele'); b.remove(); });
    s.appendChild(b);
  });

  /* Compteurs animes */
  var compteurs = racine.querySelectorAll('[data-cible]');
  function formater(v) { return Math.round(v).toLocaleString('fr-FR'); }
  if (io && !reduit) {
    var obsCpt = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var cible = parseFloat(el.getAttribute('data-cible')) || 0;
        var debut = null;
        obsCpt.unobserve(el);
        function pas(t) {
          if (!debut) debut = t;
          var k = Math.min(1, (t - debut) / 1400);
          el.textContent = formater(cible * (1 - Math.pow(1 - k, 3)));
          if (k < 1) window.requestAnimationFrame(pas);
        }
        window.requestAnimationFrame(pas);
      });
    }, { threshold: 0.6 });
    compteurs.forEach(function (c) { obsCpt.observe(c); });
  }
})();
